import { Component, HostListener, Input } from '@angular/core';
import { faStar, faStarHalf, faX } from '@fortawesome/free-solid-svg-icons';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { InfoMessageService } from 'src/app/services/info-message.service';
import { OrderServiceService } from 'src/app/services/orders/order-service.service';

@Component({
  selector: 'app-rate-product',
  templateUrl: './rate-product.component.html',
  styleUrls: ['./rate-product.component.scss']
})
export class RateProductComponent {

  constructor(
    public activeModal: NgbActiveModal,
    private orderService: OrderServiceService,
    private messageService: InfoMessageService
  ){}

  faX = faX;
  faStar = faStar;
  faStarHalf = faStarHalf;
  faStarRegular = faStar;

  hoverRating = 0;
  currentRating = 0;

  @Input() productName = '';
  @Input() productId = '';
  @Input() orderId = '';

  loginCarg: boolean = false;

  onNo() {
    this.activeModal.close('close');
  }

  rateProduct() {
    this.loginCarg = true;
    this.orderService.rateProduct(this.productId, this.orderId, this.currentRating).subscribe({
      next: () => {
        this.loginCarg = false;
        this.activeModal.close({ 
          success: true, 
          rating: this.currentRating,
          productId: this.productId 
        });
        
        setTimeout(() => {
          this.messageService.showMessage(
            "¡Producto calificado!",
            "Tu calificación ha sido cargada exitosamente.",
            "success"
          );
        }, 200);
      },
      error: () => {
        this.loginCarg = false;
        this.activeModal.close('firstButton');
      }
    });
    
  }

  setRating(rating: number) {
    this.currentRating = rating;
  }
  
  onMouseEnter(rating: number) {
    this.hoverRating = rating;
  }
  
  onMouseLeave() {
    this.hoverRating = 0;
  }


  @HostListener('mouseleave', ['$event'])
  onModalMouseLeave(event: MouseEvent) {
    // Verifica que el mouse realmente salió del modal
    if (!event.relatedTarget || !this.isDescendant(event.relatedTarget as HTMLElement)) {
      this.hoverRating = 0;
    }
  }

  private isDescendant(element: HTMLElement): boolean {
    const modal = document.querySelector('.modal-content'); // Ajusta el selector según tu modal
    return modal ? modal.contains(element) : false;
  }
}
